import appConfig from './config.js';
import axios from 'axios';
import store from '../store';
import {
	MessageBox,
	Message
} from 'element-ui';

// axios配置
axios.defaults.baseURL = appConfig.domain;


// 请求拦截器
axios.interceptors.request.use(
	config => {
		// 自定义请求头
		if(store.state.userInfo){
			config.headers.token = store.state.userInfo.token;
		}
		
		config.headers.userType = 1; //后台用户标识
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//  响应拦截器
axios.interceptors.response.use(
	response => {
		if (response.data.code == 410) {
			window.location.href = "/admin.html#/login";
			return;
		}

		if (response.data.code == 420) {
			MessageBox.alert("登录信息超时，请重新登录！", '登录超时', {
				confirmButtonText: '跳转登录页面',
				showClose: false,
				callback: action => {
					window.location.href = "/admin.html#/login";
				}
			});
			return;
		}

		if (response.data.code != 200) {
			Message.error(response.data.msg);
		}

		return Promise.resolve(response);
	},
	err => {
		Message.error('请求错误！');
		return Promise.reject(err);
	}
)

export default {
	domain: appConfig.domain,
	post(url, params = {}) {
		return new Promise((resolve, reject) => {
			axios.post(url, params)
				.then(res => {
					return resolve(res.data);
				})
				.catch(err => {
					return reject(err.data)
				})
		});
	},
	get(url, data = {}) {
		return new Promise((resolve, reject) => {
			let datas = {};
			datas.params = data;
			axios.get(url, datas).then(res => {
				return resolve(res.data);
			}).catch(err => {
				return reject(err.data)
			})
		});
	}
}
